import { DataSource, Layout } from "@mcleod/components";

export abstract class AutogenLayoutMultiReprintFreightBill extends Layout {
    sourceMultiReprintFreightBill: DataSource;
}
